var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBucketsUnselected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-buckets-unselected_svg__clip0_1847_6621)",
    stroke: "currentColor",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.706 4.75a9.346 9.346 0 001.197-.374L12.65 14.561l-.008.039a.823.823 0 01-.123.085c-.194.114-.515.238-.964.35-.889.222-2.148.365-3.562.365-1.414 0-2.673-.143-3.562-.365-.449-.112-.77-.236-.963-.351a.817.817 0 01-.123-.086l-.009-.04L1.095 4.378c.352.14.755.265 1.191.374 1.483.368 3.5.59 5.707.59s4.227-.222 5.713-.59zm-1.041 9.825l-.004.006a.023.023 0 01.004-.006zm-9.343 0s.002 0 .004.004l-.004-.005zM15.257 1.964c-.029.04-.106.125-.31.246-.328.193-.842.387-1.53.559-1.366.34-3.285.556-5.424.556-2.14 0-4.054-.214-5.417-.553-.686-.17-1.198-.364-1.525-.556-.208-.124-.284-.21-.31-.249.026-.038.102-.126.314-.25.329-.194.844-.388 1.533-.56C3.956.817 5.875.6 8.007.6c2.132 0 4.047.217 5.411.558.687.172 1.2.366 1.528.56.205.12.282.206.31.246z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-buckets-unselected_svg__clip0_1847_6621"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
export default SvgIconBucketsUnselected;